import React, { useContext } from 'react';
import { insightsContext } from '../../../context/insightsContext';
import caretRight from '../../../assets/images/icons/caret-right.svg';
import Styles from './NavigationArrows.module.scss';

const NavigationArrows = (props) => {
  const insights = useContext(insightsContext);
  const { state, dispatch } = insights;
  const { data, currentInsight } = state;
  const { fetchingAuthorInfo, bottomNav } = props;

  const scrollToTop = () => {
    const dasboardButton = document.getElementById('dasboardRedirect');
    dasboardButton.scrollIntoView({ behavior: 'smooth' });
  };

  const handleNavigateClick = (index) => {
    if (index === data.length) {
      dispatch({ type: 'SET_INSIGHT', index: 0 });
    } else if (index < 0) {
      dispatch({ type: 'SET_INSIGHT', index: data.length - 1 });
    } else {
      dispatch({ type: 'SET_INSIGHT', index });
    }
    if (bottomNav) {
      scrollToTop();
    }
  };

  return (
    <span className={`${Styles.navigator} ${fetchingAuthorInfo ? Styles.disable : ''}`}>
      <button
        type='button'
        aria-label='navigation-arrow-previous'
        className={Styles.leftArrow}
        onClick={() => !fetchingAuthorInfo && handleNavigateClick(currentInsight - 1)}
      >
        <img
          src={caretRight}
          alt='caret-left'
        />
      </button>
      {currentInsight + 1}/{data.length}
      <button
        type='button'
        aria-label='navigation-arrow-next'
        onClick={() => !fetchingAuthorInfo && handleNavigateClick(currentInsight + 1)}
      >
        <img
          src={caretRight}
          alt='caret-right'
        />
      </button>
    </span>
  );
};

export default NavigationArrows;
